/**
 * The vocabulary of translated content, shared by everything that reads it.
 *
 * `namespace` is a PATH SEGMENT on three admin routes and a column in
 * `translations`, so what counts as one has to be the same answer in the
 * worker's route guards, in the panel's editor, and in the schema. It was
 * declared twice and re-exported twice more, and the two declarations had
 * already grown different signatures -- `value: string` in one, `unknown` in
 * the other.
 *
 * `isNamespace` takes `unknown` so that a caller holding a value it has not
 * parsed yet cannot be forced to cast its way in. No call site needs that
 * today: Hono infers `c.req.param("namespace")` as `string` and the panel
 * passes an input value. The wider signature costs nothing and removes the
 * question.
 *
 * `NAMESPACES` is pinned against the `CHECK` on `translations.namespace` by
 * `worker/test/schema/constants.test.ts`, which is what keeps this list and
 * the database from drifting apart.
 */
export const NAMESPACES = ["site", "email"];
export function isNamespace(value) {
    return typeof value === "string" && NAMESPACES.includes(value);
}
//# sourceMappingURL=i18n.js.map